import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'

// UI labels: `useLoyaltyFilterLabels` (see `src/client/components/Search/AGENTS.md`).

export const LOYALTY_SEARCH_FILTER_PARAM = 'loyalty'
export const LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE = 'free_room_upgrade'
export const LOYALTY_SEARCH_FILTER_VALUES = [LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE]

/** Anywhere/anytime hotel search filtered to stay-upgrade eligible offers. */
export const LOYALTY_STAY_UPGRADE_OFFER_LIST_FILTERS: App.OfferListFilters = {
  destinations: [ANYWHERE_PLACE_ID],
  destinationId: ANYWHERE_PLACE_ID,
  destinationName: ANYWHERE_NAME,
  destinationNames: [ANYWHERE_NAME],
  loyalty: [LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE],
  offerTypes: ['hotel'],
}
